export default __webpack_public_path__ + "img/equipments-specialties-banner.asset.2d9b83c3.png";